export default "__VITE_ASSET__qGhH05OO__"